import { z } from 'zod';

export const RagDocumentStatusSchema = z.enum([
  'pending',
  'failed',
  'success',
  'raw',
]);

export const RagDocumentImportSourceSchema = z.enum([
  'knowledge_base',
  'database',
]);

export const RagDocumentSchema = z.object({
  userUuid: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  clientId: z.number(),
  type: z.string(),
  filename: z.string(),
  status: RagDocumentStatusSchema,
  fileId: z.string(),
  userId: z.number(),
  createdAt: z.string(),
  description: z.string().nullable(),
  importSource: RagDocumentImportSourceSchema.nullish(),
  chatSessionId: z.string().nullish(),
});

export const DocumentUploadRequestSchema = z.object({
  file: z.instanceof(File),
  description: z.string().nullish(),
  // Multipart field keys are sent as-is (no snake_case conversion), so this
  // optional field uses the literal backend key `chat_session_id`.
  chat_session_id: z.string().nullish(),
});

export const StorageUsageSchema = z.object({
  usedBytes: z.number(),
  limitBytes: z.number(),
  usedPercent: z.number(),
});
